
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-subject-right-request",
      function () {
        return require("private-next-pages/data-subject-right-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-subject-right-request"])
      });
    }
  